import { TextControl, PanelBody } from "@wordpress/components";
import IconDisplay from "../../../../components/IconDisplay";
import { __ } from "@wordpress/i18n";

export default function DefaultStateSettings({ attributes, setAttributes }) {
  const { addedText, addedIcon, useIcon = true } = attributes;

  return (
    <>
      <PanelBody
        title={__("Added State Settings", "brandy-blocks")}
        initialOpen={true}
      >
        <div>
          <TextControl
            __nextHasNoMarginBottom
            label={__("Added Text", "brandy-blocks")}
            help={__("Leave it empty to hide", "brandy-blocks")}
            value={addedText ?? ""}
            onChange={(value) => setAttributes({ addedText: value })}
          />
        </div>
        {useIcon && (
          <div style={{ marginTop: "10px" }}>
            <IconDisplay
              name={addedIcon.name}
              type={addedIcon.type}
              handleChangeAttributes={(updates) =>
                setAttributes({ addedIcon: { ...addedIcon, ...updates } })
              }
            />
          </div>
        )}
      </PanelBody>
    </>
  );
}
